import React, { useState } from "react";
import { errorState } from "../state";
import AssetUpdateMedallion from "../../AssetUpdateMedallion";

interface FooterProps {
  ableToEdit: boolean;
  readonly: boolean;
  setReadonly: (value: boolean) => void;
  dataHasChanged: boolean;
  submitAsset: () => void;
  showConfirmDialog: () => void;
  errorState?: errorState;
  isSameLMS?: boolean;
  isInputDisabled?: boolean;
}
export const Footer = ({
  ableToEdit,
  readonly,
  setReadonly,
  dataHasChanged,
  submitAsset,
  showConfirmDialog,
  errorState,
  isSameLMS,
  isInputDisabled,
}: Readonly<FooterProps>) => {
  const disabled = Boolean(isInputDisabled);

  const handleDiscardChanges = () => {
    if (disabled) return;
    if (dataHasChanged) {
      showConfirmDialog();

      return;
    }

    setReadonly(!readonly);
  };

  const [showAssetUpdateMedallion, setShowAssetUpdateMedallion] = useState(false);

  return (
    <div className="assetManager-metadataeditor-footer">
      <div className="assetManager-metadataeditor-errormsg">
        {errorState?.hasError && <p> {errorState.errorMessage}</p>}
      </div>
      <div className="assetManager-metadataeditor-footer-btns">
        {ableToEdit && (
          <>
            {readonly && (
              <>
                {isSameLMS && (
                  <button
                    className={`assetManager-button ${disabled ? "disabled" : "gray"} update-asset`}
                    disabled={disabled}
                    onClick={() => {
                      if (disabled) return;
                      setShowAssetUpdateMedallion(true);
                    }}
                  >
                    Update Asset
                  </button>
                )}
                <button
                  className={`assetManager-button ${disabled ? "disabled" : "gray"}`}
                  disabled={disabled}
                  onClick={() => {
                    if (disabled) return;
                    setReadonly(!readonly);
                  }}
                >
                  Edit Data
                </button>
              </>
            )}
            {!readonly && (
              <button
                className="assetManager-button white"
                onClick={() => handleDiscardChanges()}
                style={{
                  marginLeft: dataHasChanged ? "" : "auto",
                  marginRight: dataHasChanged ? "15px" : "",
                }}
              >
                {`${dataHasChanged ? "Discard changes" : "Cancel"}`}
              </button>
            )}
          </>
        )}
        {!readonly && (
          <>
            {dataHasChanged && (
              <button
                onClick={() => {
                  if (errorState?.hasError || disabled || !isSameLMS) return;
                  submitAsset();
                }}
                disabled={disabled || !isSameLMS}
                className={`assetManager-button ${
                  errorState?.hasError || disabled || !isSameLMS ? "disabled" : "gray"
                }`}
                style={{
                  marginRight: "0",
                }}
              >
                Save Changes
              </button>
            )}
          </>
        )}
      </div>
      {showAssetUpdateMedallion && <AssetUpdateMedallion onClose={() => setShowAssetUpdateMedallion(false)} />}
    </div>
  );
};

export default Footer;
